import { render, staticRenderFns } from "./LoadList.vue?vue&type=template&id=6b5f1349&scoped=true"
import script from "./LoadList.vue?vue&type=script&lang=js"
export * from "./LoadList.vue?vue&type=script&lang=js"
import style0 from "./LoadList.vue?vue&type=style&index=0&id=6b5f1349&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5f1349",
  null
  
)

export default component.exports